import { IconButton as MuiIconButton } from "@mui/joy";

export default function IconButton(props: any) {
    return (
        <MuiIconButton
            variant="soft"
            color="primary"
            size={"sm"}
            sx={{ borderRadius: "md", border: "1px solid", borderColor: "divider" }}
            {...props}
        />
    );
}
